// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"BreadCrumbs_breadcrumbs__DqX6q","crumb":"BreadCrumbs_crumb__SfqA1","listName":"BreadCrumbs_listName__ksZsZ"};